if (typeof CustomInventoryMessage === 'undefined') {
  if (!customElements.get('custom-inventory-message')) {
    class CustomInventoryMessage extends HTMLElement {
      constructor() {
        super();
        this.items = Array.from(this.querySelectorAll('.custom-inventory-message__item'));
        this.mainSection = this.closest("[data-section-type='product']");
        this.selectedVariantId = parseInt(this.dataset.selectedOrFirstAvailableVariantId, 10);
        this.boundHandleVariantChanged = this.handleVariantChanged.bind(this);

        const inventoryNode = this.querySelector('[data-variants-inventory]');
        this.variantsInventory = inventoryNode ? JSON.parse(inventoryNode.textContent) : { variants: [] };

        this.items.forEach((item) => {
          const startAttr = item.getAttribute('data-start');
          const endAttr = item.getAttribute('data-end');
          item.dataset.hasStart = startAttr !== null && startAttr !== '';
          item.dataset.hasEnd = endAttr !== null && endAttr !== '';

          if (!item.dataset.hasStart && !item.dataset.hasEnd && !item.hasAttribute('data-policy')) {
            item.dataset.unavailable = 'true';
          }

          if (!item.dataset.templateOriginal) {
            item.dataset.templateOriginal = item.innerHTML.trim();
          }
        });
      }

      connectedCallback() {
        if (!this.items.length) {
          return;
        }

        if (this.mainSection) {
          this.mainSection.addEventListener('variant:changed', this.boundHandleVariantChanged);
          this.handleVariantChanged({ detail: { variant: { id: this.selectedVariantId } } });
        } else {
          this.updateMessage(this.selectedVariantId);
        }
      }

      disconnectedCallback() {
        if (this.mainSection && this.boundHandleVariantChanged) {
          this.mainSection.removeEventListener('variant:changed', this.boundHandleVariantChanged);
        }
      }

      handleVariantChanged(event) {
        const variantId = parseInt(event?.detail?.variant?.id, 10);
        if (!variantId) {
          this.hide();
          return;
        }

        this.updateMessage(variantId);
      }

      updateMessage(variantId) {
        if (!variantId) {
          this.hide();
          return;
        }

        const variantInventory = this.variantsInventory?.variants?.find((variant) => variant.id === variantId);
        if (!variantInventory) {
          this.hide();
          return;
        }

        const quantity = parseInt(variantInventory.inventory_quantity, 10) || 0;
        const effectiveQuantity = Math.max(quantity, 0);
        const continueSelling =
          Boolean(variantInventory.continue_selling_when_out_of_stock) ||
          variantInventory.inventory_policy === 'continue';
        const isAvailable = Boolean(variantInventory.available);

        let matchedItem = null;

        this.items.forEach((item) => {
          item.classList.remove('active');

          const startAttr = item.dataset.start;
          const endAttr = item.dataset.end;
          const requiresUnavailable = item.dataset.unavailable === 'true';

          const hasStart = startAttr !== undefined && startAttr !== '';
          const hasEnd = endAttr !== undefined && endAttr !== '';
          const start = hasStart ? parseInt(startAttr, 10) : null;
          const end = hasEnd ? parseInt(endAttr, 10) : null;

          const matchesStart = !hasStart || (!Number.isNaN(start) && effectiveQuantity >= start);
          const matchesEnd = !hasEnd || (!Number.isNaN(end) && effectiveQuantity <= end);
          const matchesAvailability = !requiresUnavailable || !isAvailable;

          let matchesPolicy = true;
          const policyPreference = item.dataset.policy;
          if (policyPreference && quantity <= 0) {
            const requiresContinue = policyPreference === 'true';
            matchesPolicy = requiresContinue ? continueSelling : !continueSelling;
          }

          if (matchesStart && matchesEnd && matchesPolicy && matchesAvailability && !matchedItem) {
            matchedItem = item;
          }
        });

        if (!matchedItem) {
          this.hide();
          return;
        }

        let message = matchedItem.dataset.templateOriginal || matchedItem.innerHTML;
        if (message.indexOf('[quantity]') !== -1) {
          message = message.replace(/\[quantity\]/gi, quantity);
        }
        matchedItem.innerHTML = message;

        matchedItem.classList.add('active');
        this.classList.add('active');
      }

      hide() {
        this.classList.remove('active');
        this.items.forEach((item) => {
          item.classList.remove('active');
          if (item.dataset.templateOriginal) {
            item.innerHTML = item.dataset.templateOriginal;
          }
        });
      }
    }

    customElements.define('custom-inventory-message', CustomInventoryMessage);
  }
}

